import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import { useGetPracticeManagementQuery } from "../../../api/user/gestisciPraticheApi.js";
import { t } from "i18next";
import { useEffect, useState } from "react";
import CoreFilterButtonIcon from "../../../../app/core/components/CoreFilterButtonIcon/CoreFilterButtonIcon.jsx";
import { Button, Popover } from "@mui/material";
import CoreInputField from "../../../../app/core/components/CoreInputField/CoreInputField.jsx";
import PracticeFilter from "../../../../app/core/components/PracticeFilter/PracticeFilter.jsx";
import CoreChip from "../../../../app/core/components/CoreChip/CoreChip.jsx";
import { labelForFilterPracticeUser } from "../../../../utils/functions/filters.js";

const FilterActivityUser = ({ filter, setFilter }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPractice, setSelectedPractice] = useState(null);
  const [debouncedInputPracticeValue, setDebouncedInputPracticeValue] =
    useState("");

  const page = {
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  };

  const { data: practicesData, isLoading } = useGetPracticeManagementQuery({
    page,
    filter: {
      status: "",
      startDate: "",
      endDate: "",
    },
  });

  useEffect(() => {
    handleFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    if (selectedPractice?.value)
      setFilter({
        ...filter,
        practiceId: selectedPractice?.value,
      });
    else
      setFilter({
        ...filter,
        practiceId: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPractice?.value]);

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFilter({
      ...filter,
      [name]: value,
    });
  };

  const handleFilter = () => {
    setFilter(filter);
  };

  const handleReset = () => {
    setFilter({
      status: "",
      startDate: "",
      endDate: "",
    });
    setSelectedPractice(null);
    handleClosePopover();
  };

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) {
        newFilter[k] = "";
        if (k === "startDate") newFilter["endDate"] = "";
      }
    });
    setFilter(newFilter);
    setSelectedPractice(null);
  };

  return (
    <div className="flex flex-row  justify-end space-x-2">
      {Object.entries(filter).map(
        ([k, v]) =>
          v !== "" && (
            <CoreChip
              key={v}
              label={labelForFilterPracticeUser(k, v, practicesData)}
              variant="outlined"
              onDelete={() => handleRemoveFilter(v)}
            />
          )
      )}
      <CoreFilterButtonIcon onOpen={handleOpenPopover} />

      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { borderRadius: "8px", marginTop: "5px" } }}
      >
        <div className="w-[32rem] p-4">
          <form>
            <div className="flex flex-col">
              <h3 className="m-0">{t("Practice")}</h3>
              <PracticeFilter
                selectedUser={selectedPractice}
                setSelectedUser={setSelectedPractice}
                usersList={
                  practicesData?.Data?.items.map((el) => ({
                    label: el.name,
                    value: el.id,
                  })) || []
                }
                isUsersLoading={isLoading}
                setDebouncedInputUserValue={setDebouncedInputPracticeValue}
              />
            </div>
            <div className="flex flex-col">
              <h3 className="m-0">{t("Date")}</h3>
              <div className="flex space-x-4">
                <CoreInputField
                  name="startDate"
                  type="date"
                  value={filter.startDate}
                  onChange={handleInputChange}
                  className={"w-full"}
                  label={t("StartDate")}
                  focused
                  color="grey"
                />

                <CoreInputField
                  name="endDate"
                  type="date"
                  value={filter.endDate}
                  onChange={handleInputChange}
                  className={"w-full"}
                  label={t("EndDate")}
                  focused
                  color="grey"
                />
              </div>
            </div>
            <div className="flex space-x-4">
              <Button
                className="bg-red-700 text-white w-full"
                onClick={handleReset}
                sx={{ marginTop: "16px" }}
              >
                Reset
              </Button>
            </div>
          </form>
        </div>
      </Popover>
    </div>
  );
};

export default FilterActivityUser;
